import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Overlays from '@project/shared/utils/overlays/js/overlays';
import * as Cookies from 'js-cookie';

const classes = {
	regionIcon: 'm-navigation-meta__selected-item',
	regionPopup: 'regionPopup',
	closeIcon: 'closeIcon',
	link: 'js-m-region-lightbox__link',
};

@createModule('RegionLightbox')

export class RegionLightbox extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {		
		this.$ctx = $(this._ctx);

		if (!this.hasUserInteracted()) {
			Overlays.ShowOverlay(() => {
				this.$ctx.find(`.${classes.regionPopup}`).show();

				this.$ctx.find(`.${classes.link}`).on('click', this.adjustLinkUrl.bind(this));
				var getApiUrl = this.$ctx.find('.popupBody').attr("getUrl")
				$.ajax({
					method: 'get',
					url: getApiUrl,
					success: this.getRegionData.bind(this),
				});
			}, 250);
		}
		
		this.$ctx.find(`.${classes.closeIcon}`).on('click', () => {
			this.markUserHasInteracted();

			Overlays.CloseOverlay(() => { 
				this.$ctx.find(`.${classes.regionPopup}`).hide();
			});
		});
	}

	getRegionData(data: any) {
		console.log(data);
		var regionLabel = data.RegionId;
		var countryLabel = data.CountryId;
		var regionsList = data.Regions;
		var regions = document.querySelector('[name=regions]');
		var options = '<option>Select Region</option>';
		var regionDropdown = $('.popupBody p')[0];
		regionDropdown.firstElementChild.innerHTML = regionLabel;
		var countryDropdown = $('.popupBody p')[1];
		countryDropdown.firstElementChild.innerHTML = countryLabel;

		for(var i=0; i < regionsList.length; i++) {
			options += '<option value="' + regionsList[i].RegionCode +'">' + regionsList[i].Name +'</option>';
		}
		regions.innerHTML = options;

		regions.addEventListener('change', function(e) {
			for (var j = 0; j < regionsList.length; j++) {
				if(regionsList[j]["RegionCode"] == this.value){
					var country = '';
					for (var k = 0; k < regionsList[j].Countries.length; k++) {
						country += '<option value="' + regionsList[j].Countries[k].CountryCode +'">' + regionsList[j].Countries[k].CountryName +'</option>';
					}
				}
			}
			document.querySelector('[name=countries]').innerHTML = country;
		});
	}

	adjustLinkUrl() {
		this.markUserHasInteracted();

		const postApiUrl = $('.popupBody').attr("postUrl");		
		var countries = document.querySelector('[name=countries]');
		const CountryCode = $(countries).val();

		
		if(CountryCode){
			 $.ajax({
				 type: 'POST',
				 url: postApiUrl,
				 dataType: 'html',
				 data: {CountryCode},
				 success: (response: any) => {
					 console.log("success");
					 console.log(response);
					 $(`.${classes.regionPopup}`).hide();
						location.reload();     
				 },
				 complete: () => {
					 console.log("complete");
				 },
				 error: () => {
					 console.log("post country name data error");
				 }
			 });
		}
	}
	
	private hasUserInteracted(): boolean {
		const cookie = Cookies.get('RegionPopup');
		return cookie == "1";
	}

	private markUserHasInteracted(): void {
		Cookies.set('RegionPopup', "1", { expires: 365 });
	}

	stop() { }
	
}
